export const testType = {
    "test_type": "tests",
    "practice_type": "practices",
    "exam_type": "exam",
    "multiple_choice": "multiple choice",
    "voted": "vote",
    "survey": "survey",
    "multiple_choice_comparison": "comparison test",
    "multiple_choice_script" : "script test",
    "multiple_choice_test": "score ranged test",
};
